export default __webpack_public_path__ + "static/media/call.b3c80e31.svg";